class ProductDetailGifts extends Component {

    constructor(el) {
        super(el);
        EventBus.getInstance().addEventListener('productVariantChanged', e => this.onProductVariantChanged(e));
    }

    onProductVariantChanged({detail: variant}) {
        // Je důležité vybrat prvně div, protože DOMParser vše obalí do <html>, <body> etc.
        var doc = new DOMParser().parseFromString(variant.gifts, "text/html").querySelector("div").innerHTML; // vybereme vnitřek šablony
        this.$el.innerHTML = doc
    }

}
